import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { CheckCircleIcon } from '../icons';

const heightMap = {
  small: 32,
  medium: 36,
  large: 40,
  mini: 28,
};

const ChipStyled = styled(Chip)(({ size = 'small' }) => ({
  height: heightMap[size],
  fontSize: 14,
  '& .MuiChip-label': {
    paddingLeft: 16,
    paddingRight: 16,
  },
}));

const FilterChip = ({ label, onClick, ...props }) => {
  return (
    <ChipStyled
      icon={props.selected ? <CheckCircleIcon /> : null}
      label={label}
      onClick={onClick}
      variant="tonal"
      color={props.selected ? 'primary' : 'secondary'}
      {...props}
    />
  );
};

FilterChip.propTypes = {
  selected: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['mini', 'small', 'medium', 'large']),
};

export default FilterChip;
